



import React, { useContext, useEffect, useState } from "react";



import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";



function AddressAmendmentCompany() {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };

  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);
  // if (loading) {
  //   return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //    return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = Array.isArray(services) ? services.find(s => s.service_id === 38) : null;

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }


    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };




  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();

    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }
    if (!validateForm()) return;

      localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

  };




  const faqList = [
    {
      question: "What is a Company Address Amendment (within State)?",
      answer: "It means changing your company’s registered office address within the same state or territory."
    },
    {
      question: "How long does the process take?",
      answer: "Time varies by state and authority. Check with your local regulatory body for details."
    },
    {
      question: "What documents are required?",
      answer: "Usually an amendment form, proof of new address (like lease or utility bill), and any other required documents."
    },
    {
      question: "How do I submit the amendment?",
      answer: "Submit the form and documents online, by mail, or in person, depending on your state authority."
    },
    {
      question: "Are there any fees?",
      answer: "Yes, fees vary by jurisdiction. Check with your regulatory authority for the exact amount."
    },
    {
      question: "Why would I need to amend the address?",
      answer: "To reflect office relocation, comply with laws, and ensure proper communication."
    },
    {
      question: "Do I need to inform others?",
      answer: "Yes. Notify clients, banks, update letterheads, website, and government records."
    },
    {
      question: "Can I do it myself?",
      answer: "Yes, but it’s better to consult a professional to avoid mistakes and ensure compliance."
    }
  ];





  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>

                <h1 className="sk-text-color">Company Address Amendment (within State)</h1>

                <p className="pdrl-text">Get Company Address Amendment (within State) for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                <p className="pd-text">At DM2Legal, our dedicated experts guide you through every step, ensuring accuracy and speed. Start and grow your business with confidence — fast, simple, and dependable legal support from DM2Legal.</p>

                <div className="banner">
                  <img src="assets/icons/banner.svg" alt="" srcset="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now</h3>         <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">


            <div className="col-lg-12">

              {/* <h2>Annual Compliance LLP </h2> */}


              <p className="pd-text">Every company in India must register its official address with the MCA. While branches can be opened freely, any change in the registered office must be reported to the ROC within 15 days using Form INC-22. If the change crosses ROC jurisdictions, Form INC-23 and Regional Director approval are needed.

                DM2Legal makes company address updates quick and hassle-free. Our experts handle everything smoothly and on time.
              </p>
            </div>

          </div>


        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Address-Amendment-Within-state-(Company).png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate text-center">Benefits </h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon1.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Stay Legally Compliant</a></h4>
                  <p className="font-f-7">Updating your company’s registered office address is essential for meeting legal requirements. Keeping this information current in official records ensures compliance with regulatory bodies and facilitates smooth communication with government agencies, shareholders, and stakeholders.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon2.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Accurate Official Records</a></h4>
                  <p className="font-f-7">When your registered office address is up to date, important documents like your certificate of incorporation or business registration reflect the correct details. This helps avoid discrepancies and confusion when dealing with banks, regulatory authorities, or other third parties.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon3.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Uninterrupted Communication</a></h4>
                  <p className="font-f-7">A current registered office address ensures timely receipt of critical notices, legal documents, and official correspondence. It allows for efficient interaction with government entities, customers, suppliers, and business partners—reducing the risk of missed messages or delays.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon5.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Proper Delivery of Legal Notices</a></h4>
                  <p className="font-f-7">Making sure your address is accurate ensures that legal notices, court summons, and other official communications reach you without delay. This is vital for responding within the necessary timeframes and protecting your company’s interests.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon6.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Uphold Your Good Standing</a></h4>
                  <p className="font-f-7">Keeping your address updated reflects your company’s commitment to compliance and responsible management. It reinforces your credibility and helps maintain a positive reputation with regulators and stakeholders.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/service6-icon4.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Avoid Penalties</a></h4>
                  <p className="font-f-7">Delays in updating your address can lead to fines, penalties, or other regulatory consequences. With DM2Legal, you can quickly make the necessary changes and stay ahead of any compliance issues.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/brand6-4.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Ensure Business Continuity</a></h4>
                  <p className="font-f-7">Accurate address information helps avoid disruptions during key processes such as audits, legal matters, or major transactions. It ensures important documents and notices are delivered promptly, keeping your business running smoothly.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="service6-box s-box">
                <div className="box-img">
                  <div className="service-box-icon box-icon">
                    <img src="assets/img/icons/work6-icon3.png" alt="" />
                  </div>
                </div>
                <div className="hadding6">
                  <h4><a href="#" className="font-f-7">Boost Your Professional Image</a></h4>
                  <p className="font-f-7">A current and correct address not only fulfills legal obligations—it also enhances your company's image. It shows you're detail-oriented, law-abiding, and professional—qualities that matter to clients, investors, and partners alike.</p>
                </div>
              </div>
            </div>

          </div>


          <div className="space20"></div>
        </div>
      </div>

      <div className="service-binifits9 sp0" id="service2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Online Registration Procedure </h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li>
                    <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>DM2Legal reviews your documents to ensure there’s no incorrect or misleading information.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>We assist with all document and license requirements.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Once forms and formalities are complete, we’ll notify you.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>After submission and fee payment, please wait for regulatory approval.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>We'll share confirmation once your new registered office address is officially approved.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                    <div className="space30"></div>
                    <div id="general">


                      {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      < WhatsAppScrollButton />

      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default AddressAmendmentCompany;
